import StandardSwipe from './StandardSwipe';
import initSliders from './initSliders';
export { StandardSwipe, initSliders };